import Cookies from "universal-cookie";
import sales from "../../Sales";
import { sessionExpired } from "../hooks/useSessionGuard";
import { withSoldCounts } from "../utils/serviceCounts";

const cookies = new Cookies();

// Alle cijfers die het dashboard nodig heeft, in één keer ophalen.

// Een deel van de kaarten gaat over de vorige maand ("beste verkoper",
// "totaal vorige maand"), dus die rekenen we hier alvast uit.
function previousMonth(month, year) {
  const m = parseInt(month, 10);
  const y = parseInt(year, 10);
  return m === 1 ? { month: 12, year: y - 1 } : { month: m - 1, year: y };
}

function endpoints(month, year) {
  const prev = previousMonth(month, year);
  return {
    rankList: `rankList?month=${month}&year=${year}`,
    teamTarget: `teamTarget?month=${month}&year=${year}`,
    soldServices: `mostSoldProducts?month=${month}&year=${year}`,
    yearRankList: `yearRankList?month=${month}&year=${year}`,
    bestSeller: `bestSeller?month=${prev.month}&year=${prev.year}`,
    deals: `getDeals?month=${prev.month}&year=${prev.year}`,
    existantDeals: `getDeals?month=${month}&year=${year}&status=0`,
    dealList: "deals",
    products: "products",
  };
}

const extras = new Set(["dealList", "products"]);

// Haalt één endpoint op. Gaat er iets mis, dan geeft hij geen data terug in
// plaats van de hele boel te laten klappen - één kapotte kaart mag de rest
// niet meeslepen.
async function getOne(key, url, signal) {
  try {
    const response = await sales.get(url, { signal });
    if (response.status < 200 || response.status >= 300) {
      console.error(`[dashboard] ${key} → HTTP ${response.status}`);
      return { key, data: null };
    }
    return { key, data: response.data };
  } catch (error) {
    // Afgebroken omdat er een nieuwe aanvraag start: doorgeven, geen fout.
    if (error.name === "AbortError" || error.name === "CanceledError") throw error;
    // Token afgewezen: opnieuw proberen heeft geen zin, terug naar inloggen.
    if (error.response?.status === 401 && !extras.has(key)) {
      cookies.remove("token", { path: "/" });
      window.dispatchEvent(new Event(sessionExpired));
    }
    const reason = error.response
      ? `HTTP ${error.response.status}`
      : error.message || "netwerkfout";
    console.error(`[dashboard] ${key} → ${reason}`);
    return { key, data: null };
  }
}

// Geeft { data, okCount, ok } terug. okCount zegt hoeveel endpoints het
// deden en ok welke, zodat de aanroeper kan besluiten om het opnieuw te
// proberen.
export async function fetchDashboard(month, year, signal) {
  const results = await Promise.all(
    Object.entries(endpoints(month, year)).map(([key, url]) =>
      getOne(key, url, signal),
    ),
  );

  const raw = {};
  const ok = {};
  let okCount = 0;
  results.forEach(({ key, data }) => {
    if (data === null || data === undefined) return;
    if (!extras.has(key)) okCount += 1;
    ok[key] = true;
    raw[key] = data;
  });

  // rankList komt binnen als [lijst, totaalbedrag].
  const [rankList = [], amount = 0] = Array.isArray(raw.rankList)
    ? raw.rankList
    : [];

  const teamTarget = raw.teamTarget || {};
  // Telt ook boven het target door, zodat het percentage voorbij 100 kan.
  const scoredTowardsTarget = amount;

  return {
    okCount,
    ok,
    data: {
      teamTarget,
      bestSeller: raw.bestSeller || {},
      deals: raw.deals || {},
      existantDeals: raw.existantDeals || {},
      soldServices: withSoldCounts(raw.soldServices || [], raw.dealList, raw.products, month, year),
      yearRankList: raw.yearRankList || [],
      rankList,
      amount,
      scoredTowardsTarget,
    },
  };
}
